import _ from 'lodash';
import React from 'react';
import AccountingIntegrationFilter from '~/components/filters/AccountingIntegrationFilter';
import CreditNoteSentFilter from '~/components/filters/CreditNoteSentFilter';
import CreditNoteStatusFilter from '~/components/filters/CreditNoteStatusFilter';
import { useIntegrations } from '~/contexts/IntegrationsContext';
import FiltersGroup from './FiltersGroup';

export default function CreditNoteFiltersGroup({ filters, onChange }) {
  const integrations = useIntegrations();
  return (
    <FiltersGroup
      label="Credit Note Filters"
      filters={[filters.creditNoteStatuses, filters.creditNoteSent, filters.creditNoteAccountingIntegrations]}>
      {_.has(filters, 'creditNoteStatuses') && (
        <CreditNoteStatusFilter
          value={filters.creditNoteStatuses}
          onChange={({ target: { value } }) => onChange({ creditNoteStatuses: value })}
        />
      )}

      {_.has(filters, 'creditNoteSent') && (
        <CreditNoteSentFilter
          value={filters.creditNoteSent}
          onChange={({ target: { value } }) => onChange({ creditNoteSent: value })}
        />
      )}

      {integrations.accounting && _.has(filters, 'creditNoteAccountingIntegrations') && (
        <AccountingIntegrationFilter
          value={filters.creditNoteAccountingIntegrations}
          onChange={({ target: { value } }) => onChange({ creditNoteAccountingIntegrations: value })}
        />
      )}
    </FiltersGroup>
  );
}
